import { ApiBase } from '@/api/api'
import { makePostRequest } from '@/api/fetchCalls'
import {
  MFASettingsProps,
  MFASettingsResponse,
  MFASettingsSetupProps,
  MFASettingsSetupResponse,
  MFASettingsVerifyProps,
} from '@/types/mfa-settings'

export async function disableMFA(
  data: MFASettingsProps
): Promise<MFASettingsResponse> {
  const body = JSON.stringify(data)
  return (await makePostRequest(`${ApiBase}/users/me/mfa`, {
    body,
  })) as Promise<MFASettingsResponse>
}

export async function setupMFA(
  data: MFASettingsSetupProps
): Promise<MFASettingsSetupResponse> {
  const body = JSON.stringify(data)
  return (await makePostRequest(`${ApiBase}/users/me/mfa`, {
    body,
  })) as Promise<MFASettingsSetupResponse>
}

export async function verifyMFA(
  data: MFASettingsVerifyProps
): Promise<MFASettingsResponse> {
  const body = JSON.stringify(data)
  return (await makePostRequest(`${ApiBase}/users/me/mfa`, {
    body,
  })) as Promise<MFASettingsResponse>
}
